<template>
    <div>

        <div class="d-flex align-items-start">
            <h2>
                <i class="fa fa-search"></i>
                Zoeken
            </h2>
            <div class="ms-auto mt-2">
                <button v-on:click="updateComponentVisability(componentId)" class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#offers" aria-expanded="true" aria-controls="offers">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <div v-if="loading">
            <div class="loading-spinner"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></div>
        </div>

        <div class="fade-in" :class="{ 'loaded': true }">

            <div class="collapse" :class="{'show': componentIsVisable}" id="offers">

                <div class="mb-4 flex gap-2">
                    <div class="flex-grow">
                        <!-- Eerste rij met volledig breedte zoekveld -->
                        <div class="w-full mb-2">
                            <input
                                type="text"
                                class="w-full form-control"
                                v-model="searchQuery"
                                v-on:click="clearInputZip()"
                                placeholder="Zoek op dossier of opdracht #"
                                v-on:keyup.enter="searchEntities()"
                            >
                        </div>
                        <!-- Tweede rij met postcode en huisnummer -->
                        <div class="w-full flex gap-2">
                            <div class="flex-1">
                                <input
                                    type="text"
                                    class="w-full form-control"
                                    v-model="searchQueryZipCode"
                                    v-on:click="clearInputSearch()"
                                    placeholder="Zoek op postcode"
                                    v-on:keyup.enter="searchEntities()"
                                >
                            </div>
                            <div class="flex-1">
                                <input
                                    type="text"
                                    class="w-full form-control"
                                    v-model="searchQueryHouseNo"
                                    v-on:click="clearInputSearch()"
                                    placeholder="Zoek op huisnummer"
                                    v-on:keyup.enter="searchEntities()"
                                >
                            </div>
                        </div>
                    </div>
                    <!-- Zoekknop met volledige hoogte -->
                    <button
                        class="btn btn-outline-secondary h-full flex items-center justify-center"
                        type="button"
                        @click="searchEntities()"
                    >
                        <i class="fa fa-search" :class="{ 'fa fa-circle-o-notch fa-spin' : this.searchLoader }"></i>
                    </button>
                </div>


                <div v-if="showResults" class="mb-3">
                    <label class="form-label fw-semibold">Zoekresultaten</label>

                    <div v-if="searchResults.length > 0" class="mb-3">
                        <div class="list-group">
                            <a
                                v-for="(result, index) in searchResults"
                                :key="`${result.id}-${index}`"
                                :href="result.item_url"
                                class="list-group-item list-group-item-action"
                                target="_blank"
                            >
                                <div class="w-full flex gap-2">
                                    <div>{{ result.item_dossier_nr }}</div>
                                    <div>{{ result.item_name }}</div>
                                    <div class="ms-auto">
                                        <small class="d-block text-muted">{{ result.item_status }}</small>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div v-else class="mb-3">Geen resultaten gevonden</div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {useComponentVisibility} from "../../composables/useComponentVisibility";

export default {
    name: 'offers',
    props: {
        isVisible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            offers: [{
                id: '',
                item_dossier_nr: '',
                item_status: '',
                item_name: '',
                item_url: '',
                updated_at: '',
            }],
            searchQuery: '',
            searchQueryZipCode: '',
            searchQueryHouseNo: '',
            searchResults: [],
            showResults: false,
            searchLoader: false,

            componentId: 'offers-search-component',
            componentIsVisable: this.isVisible,
            componentVisibility: useComponentVisibility(),
            loading: false,
        }
    },
    computed: {},
    watch: {},
    methods: {
        updateComponentVisability(component_id) {
            // Toggle the visibility state
            this.componentIsVisable = !this.componentIsVisable;
            axios.get('api/update-component-visability', {
                params: {
                    component_id: component_id,
                    is_visable: this.componentIsVisable
                }
            });
        },
        searchEntities() {
            if (this.searchQuery.trim() === '' && this.searchQueryZipCode.trim() === '') {
                this.searchResults = [];
                this.searchLoader = false;
                return;
            }
            this.searchLoader = true;

            axios.get('api/search-entities', {
                params: {
                    query: this.searchQuery,
                    queryZipCode: this.searchQueryZipCode,
                    queryHouseNo: this.searchQueryHouseNo
                }
            })
                .then(response => {
                    if (response.data.status === 422) {
                        throw [true, response.data.message];
                    }
                    this.searchResults = response.data || [];
                    this.searchLoader = false;
                    this.showResults = true;
                })
                .catch(e => {
                    this.searchLoader = false;
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het zoeken.", "error");
                });
        },
        clearInputSearch() {
            this.searchQuery = '';
        },
        clearInputZip() {
            this.searchQueryZipCode = '';
            this.searchQueryHouseNo = '';
        },
    },
    mounted() {},
    created() {},
}
</script>
<style>
    input.form-control {
        &:disabled {
            background: #f7f7f7;
        }
    }
</style>
